import React from 'react';
import { ListGroup } from 'reactstrap';
import { SortableContainer } from 'react-sortable-hoc';

import { SortableMenuItem } from './SortableMenuItem';

export const SortableMenuItemList = SortableContainer(({ items, activeItem, onSelect, restaurantId, sortDisabled, renderActionComponent, column, styles }) => {
    const { fullWidthStyle } = styles;

    if (items !== undefined && items !== null && items.length > 0) {

        return (
            <ListGroup id={`${column}-list`} style={fullWidthStyle} flush>
                {items.map((item, i) => (
                    <SortableMenuItem
                        key={`item-${i}`}
                        index={i}
                        item={item}
                        activeItem={activeItem}
                        onSelect={onSelect}
                        restaurantId={restaurantId}
                        renderActionComponent={renderActionComponent}
                        column={column}
                        styles={styles}
                        disabled={sortDisabled}
                    />
                ))}
            </ListGroup>
        );
    } else {
        return <ListGroup style={fullWidthStyle} flush />;
    }
});


// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/SortableMenuItemList.js